import { useState, useEffect } from 'react'
import { deleteAlert } from '../api'

export default function Unsubscribe() {
    const [status, setStatus] = useState('loading') // loading | success | error | missing

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const token = params.get('token')

        if (!token) {
            setStatus('missing')
            return
        }

        deleteAlert(token)
            .then(() => setStatus('success'))
            .catch(() => setStatus('error'))
    }, [])

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'var(--font-body)',
        }}>
            {status === 'loading' && (
                <p style={{ color: 'var(--color-text-secondary)', fontSize: '15px' }}>Unsubscribing...</p>
            )}

            {status === 'success' && (
                <>
                    <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: '1.75rem', marginBottom: '0.5rem', color: 'var(--color-text-primary)' }}>
                        You've been unsubscribed
                    </h1>
                    <p style={{ color: 'var(--color-text-secondary)', fontSize: '15px', marginBottom: '1.5rem' }}>
                        Your daily alert has been removed. You won't receive any more emails.
                    </p>
                    <a href="/listings" style={{ fontSize: '14px', color: 'var(--color-text-secondary)', textDecoration: 'underline' }}>
                        Back to listings
                    </a>
                </>
            )}

            {status === 'error' && (
                <>
                    <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: '1.75rem', marginBottom: '0.5rem', color: 'var(--color-text-primary)' }}>
                        Something went wrong
                    </h1>
                    <p style={{ color: 'var(--color-text-secondary)', fontSize: '15px' }}>
                        We couldn't remove your alert. Try again or contact us.
                    </p>
                </>
            )}

            {status === 'missing' && (
                <>
                    <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: '1.75rem', marginBottom: '0.5rem', color: 'var(--color-text-primary)' }}>
                        Invalid link
                    </h1>
                    <p style={{ color: 'var(--color-text-secondary)', fontSize: '15px' }}>
                        This unsubscribe link doesn't look right. Try clicking the link in your email again.
                    </p>
                </>
            )}
        </div>
    )
}
